module.exports = __webpack_public_path__ + "static/media/googleplay.d51a34cd.svg";